import { NeoState } from '../Reducers.interface';
import { JobStatus } from '../../Models/DTO/DownloadJob.model';

export const selectAllJobs = (state: NeoState) =>
  state.downloads.downloads.jobs.filter((job) =>
    state.downloads.downloads.requestedJobs.includes(job.id),
  );

export const selectPendingJobs = (state: NeoState) =>
  state.downloads.downloads.jobs.filter(
    (job) =>
      state.downloads.downloads.requestedJobs.includes(job.id) &&
      (job.status === JobStatus.ENQUEUED || job.status === JobStatus.EXECUTING),
  );

export const selectSuccessfulJobs = (state: NeoState) =>
  state.downloads.downloads.jobs.filter(
    (job) =>
      state.downloads.downloads.requestedJobs.includes(job.id) && job.status === JobStatus.SUCCESS,
  );

export const selectFailedJobs = (state: NeoState) =>
  state.downloads.downloads.jobs.filter(
    (job) =>
      state.downloads.downloads.requestedJobs.includes(job.id) &&
      (job.status === JobStatus.FAILED || job.status === JobStatus.ERROR),
  );
